import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AdminTableSortDirection, SortEvent } from '../models/admin-table.model';

const rotate: { [key: string]: AdminTableSortDirection } = { 'asc': 'desc', 'desc': 'asc' };

@Injectable()
export class AdminTableColumnService {
    public sortObs: Observable<SortEvent>;
    private sortSubj: BehaviorSubject<SortEvent | null> = new BehaviorSubject<SortEvent | null>(null);

    constructor() {
        this.sortObs = <Observable<SortEvent>>this.sortSubj.asObservable().pipe(filter(item => item !== null));
    }

    public sort(sort: SortEvent): void {
        let currentSort: SortEvent | null = this.sortSubj.getValue();
        if (currentSort?.column === sort.column) {
            currentSort = { ...sort, direction: rotate[currentSort.direction] };
        } else {
            currentSort = { ...sort };
        }
        this.sortSubj.next(currentSort);
    }
}